export interface Movie {
  id: string;
  name: string;
  director?: string;
  year?: number;
  genre?: string;
  rating?: number; // 1-5 stars
  duration?: number; // in minutes
  status?: MovieStatus;
  posterUrl?: string;
  notes?: string;
  tags?: string[];
  dateAdded: string;
  // Properties for storing metadata (e.g., linkedNoteId)
  properties?: { [key: string]: any };
}

export enum MovieStatus {
  WANT_TO_WATCH = 'want_to_watch',
  WATCHING = 'watching',
  COMPLETED = 'completed',
  PAUSED = 'paused',
  ABANDONED = 'abandoned'
}

export interface MovieFormData {
  name: string;
  director?: string;
  year?: number;
  genre?: string;
  rating?: number;
  duration?: number;
  status?: MovieStatus;
  posterUrl?: string;
  notes?: string;
  tags?: string[];
}

